import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppTokenHandler {
    public access_token_key = 'access_token';
    access_token_value = '';
    loginUserInfo: UserInfo;
     //Added by shraddha
     public Azure_token_key = 'Azure_token';
     Azure_token_value = '';
     constructor(private cookieService: CookieService)
     {}
    getSessionToken() {       
        
        if(this.cookieService.check(this.access_token_key)){
            this.access_token_value = this.cookieService.get(this.access_token_key)!;
      }
        if (this.access_token_value == null) {
            this.access_token_value = '';
        }

        return this.access_token_value;


    }
    setSessionToken(loginData) {
        //debugger;
        this.access_token_value = loginData.access_token;
        sessionStorage.setItem('UserInfo', JSON.stringify(loginData.UserInfo));
       // sessionStorage.setItem(this.access_token_key, this.access_token_value);
       this.cookieService.set(this.access_token_key, this.access_token_value,1,null,null,true,'Lax')

    }
    clearSessionToken() {
        sessionStorage.removeItem(this.access_token_key);
    }
    getLoginUserInfo(): UserInfo {
        this.loginUserInfo = JSON.parse(sessionStorage.getItem('UserInfo'));
        return this.loginUserInfo;
        
    }
    IsInRole(role: string): boolean {
        let validRole: boolean = false;
        let loginInfo: UserInfo = this.getLoginUserInfo();
        let roles: string[] = loginInfo.Roles.split(',');
        if (roles.find(x => x.indexOf(role) >= 0)) {
            validRole = true;
        }
        return validRole;
    }
    getRole()
    {
        this.loginUserInfo = JSON.parse(sessionStorage.getItem('UserInfo'));
        let roles: string[] = this.loginUserInfo.Roles.split(',');
        return roles;
    }
    getLoginGPN()
    {
        this.loginUserInfo = JSON.parse(sessionStorage.getItem('UserInfo'));
        return this.loginUserInfo.EmpGPN;
    }
    setRequestType(RequestType: string) {
        sessionStorage.removeItem('RequestType');
        sessionStorage.setItem('RequestType', RequestType);
    }
    getRequestType() {
        let RequestType: string = "";
        if (sessionStorage.getItem('RequestType') != null)
            RequestType = sessionStorage.getItem('RequestType');;
        return RequestType;
    }
    //Added by shraddha
    setAzureTokenLocalStorage(azuretoken: any) {
        //debugger;
        this.Azure_token_value = azuretoken;
        // localStorage.setItem(this.Azure_token_key, this.Azure_token_value);
        this.cookieService.set(this.Azure_token_key, this.Azure_token_value,1,null,null,true,'Lax')

  
    }
    getAzureTokenFromLocalStorage() {
        if (localStorage.length > 0) {
            this.Azure_token_value = this.cookieService.get(this.Azure_token_key) || '';
            // this.Azure_token_value = localStorage.getItem(this.Azure_token_key) || '';
        }
        if (this.Azure_token_value == null) {
            this.Azure_token_value = '';
        }

        return this.Azure_token_value;
    }
}

export class UserInfo {
    UserId: string;
    EmpGPN: string;
    EmpEmail: string;
    EmpName: string;
    Roles: string;
    ExpiresUtc: Date;
    IsAzureInsights : boolean;
    IsAuthenticated : boolean;
}
